<template>
    <div class="pop-red-packet g-flex g-flex-column">
        <div class="title-img"></div>
        <p class="title">恭喜获得现金瓜分红包</p>
        <template v-if="data.help_count > 0">
            <div class="money g-flex-center-center">
                <p class="money-num q-number">{{ data.total_amount }}</p>
                <p class="money-unit">元</p>
            </div>
            <p class="tip">{{ data.help_count }}个红包，每个红包{{ data.amount_fen }}元</p>
            <div class="btn" @click="onInvite">邀请好友赚更多</div>
        </template>
        <template v-else>
            <div class="money g-flex-center-center">
                <p class="money-num q-number">{{ props.count }}</p>
                <p class="money-unit">个</p>
            </div>
            <p class="tip">您获得的红包将在明天12点开奖</p>

            <div class="btn" @click="jumpToIndex" v-if="store.mainData.guideToIndex">跑马拉松抽金条</div>
            <div class="btn" @click="onInvite" v-else>邀请更多好友</div>
        </template>
    </div>
</template>
<script lang="ts" setup>
import { useStore } from '@divide/store';
import { openWebview } from '@q-front-npm/jsbridge';
const store = useStore();
const data = store.mainData.share_cash_popup_data;
const props = withDefaults(
    defineProps<{
        count: number;
    }>(),
    {
        count: 0,
    }
);
const emit = defineEmits(['invite']);
const onInvite = () => {
    emit('invite');
};
const jumpToIndex = () => {
    openWebview(`https://api-marathon.wtzw.com/h5/activity/freereaderMarathon2026/sidePanel/index?full_screen=3`);
};
</script>
<style lang="scss" scoped>
.pop-red-packet {
    width: 100%;
    height: 592px;
    background: url('@divide/assets/images/divide_pop_bottonbg@3x.png') no-repeat center;
    background-size: auto 100%;
    align-items: center;
    position: relative;
}

.title {
    margin-top: 4px;
    font-weight: bold;
    font-size: 32px;
    color: #824040;
    line-height: 44px;

    &-img {
        margin-top: -86px;
        width: 100%;
        height: 134px;
        background: url('@divide/assets/images/divide_pop_headbg@3x.png') no-repeat center;
        background-size: auto 100%;
    }
}

.money {
    margin-top: 20px;
    &-num {
        font-weight: bold;
        font-size: 108px;
        color: #fa2b40;
        line-height: 118px;
    }
    &-unit {
        margin-left: 8px;
        margin-top: 36px;
        font-weight: bold;
        font-size: 36px;
        color: #fa2b40;
        line-height: 50px;
    }
}
.tip {
    margin-top: 16px;
    height: 52px;
    background: linear-gradient(270deg, rgba(255, 249, 241, 0) 0%, rgba(255, 204, 204, 0.33) 12.1%, rgba(255, 204, 204, 0.32) 51.05%, rgba(255, 204, 204, 0.32) 81.85%, rgba(255, 241, 222, 0) 100%);
    font-size: 24px;
    color: #854242;
    line-height: 52px;
    padding: 0 30px;
}

.btn {
    position: absolute;
    bottom: 64px;
    left: 0;
    right: 0;
    margin: auto;
    width: 360px;
    height: 88px;
    background: linear-gradient(180deg, #fffadb 0%, #fff3b9 100%);
    border-radius: 88px;
    font-weight: bold;
    font-size: 32px;
    color: #c21a00;
    line-height: 88px;
    text-align: center;
}
</style>
